export const isAllowedFieldForMailMerge = (item) => {
  const isVisible = item.source !== 'CAFE24' || (item.source === 'CAFE24' && item.isVisible);
  const isSystemField = item.substitution.startsWith('$') && item.source !== 'CAFE24'
  return !isSystemField && isVisible && item.substitution !== '$cafe24_subscribed';
}